import {useEffect} from 'react';

export const useScrollToTopOnUnload = () => {
  useEffect(() => {
    const handler = () => {
      window.scrollTo({top: 0});
    };

    window.addEventListener('beforeunload', handler);

    return () => {
      window.removeEventListener('beforeunload', handler);
    };
  }, []);
};
